import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { combineReducers } from 'redux';

import user from './users/user';
import users from './users';
import subscribers from './users/subscribers';
import usersLimitations from './usersLimitations';
import cargoAssigners from './cargoes/assigners';
import cargoGazetters from './cargoes/gazetters';
import cargoTypes from './cargoes/types';
import cargoDuplicates from './cargoes/duplicates';
import ldRates from './cargoes/ldRates';
import letters from './letters';
import cargoRealNames from './cargoes/realNames';
import cargoesNames from './cargoes/names';
import letter from './letter';
import termEntities from './termEntities';
import annotations from './annotations';
import gazetters from './gazetters';
import listGazetters from './listGazetters';

import preferences from './preferences/index';

// import cargoOrders from './cargoes/orders';
import cargoOrders from './cargoes/ordersNew';
import cargoRequests from './cargoes/requests';

import ports from './regions/ports';
import port from './regions/port';
import areas from './regions/areas';
import contracts from './contracts';

import vesselOrders from './vessels/orders';
import vesselRequests from './vessels/requests';
import vesselClaims from './vessels/claims';
import vessels from './vessels/vessels';
import vessel from './vessels/vessel';
import vesselSizes from './vessels/size';
import vesselSales from './vessels/sales';

import backendNotifications from './notifications/backendNotifications';
import notifications from './notifications/notifications';

import countries from './countries';
import companies from './companies';
import realCompanies from './realCompanies';

import statisticsUsers from './statistics/users';
import statisticsEmails from './statistics/emails';
import statisticsMonitor from './statistics/monitor';
import statisticsVesselPositions from './statistics/vesselPositions';
import statisticsCargoRequests from './statistics/cargoRequests';

import integrators from './integrators/integrators';
import integratorCompanies from './integrators/companies';
import companyUser from './integrators/user';

import train from './train';

import senderList from './sender/senderList';
import sender from './sender/sender';

import domains from './domains';

import reqLDRates from './reqLDRates';

import tcOrders from './tc/orders';
import tcRequests from './tc/requests';

import linksList from './analytics/linksList';

import flagCompliance from './flagCompliance';

import tcIndexes from './tc/indexes';
import cargoTagsCategories from './cargoes/tags';

import issues from './issues/issues';
import issue from './issues/issue';

export default combineReducers({
    routing: routerReducer,
    form: formReducer,
    user,
    users,
    letters,
    cargoAssigners,
    cargoGazetters,
    cargoTypes,
    cargoDuplicates,
    ldRates,
    letter,
    cargoRealNames,
    cargoesNames,
    termEntities,
    annotations,
    cargoOrders,
    ports,
    port,
    areas,
    cargoRequests,
    contracts,
    gazetters,
    listGazetters,

    preferences,

    vesselSales,
    vesselOrders,
    vesselSizes,
    vesselRequests,
    vesselClaims,
    vessels,
    vessel,

    backendNotifications,
    notifications,

    countries,
    companies,
    realCompanies,

    statisticsUsers,
    statisticsEmails,
    statisticsMonitor,
    statisticsVesselPositions,
    statisticsCargoRequests,

    usersLimitations,
    train,

    senderList,
    sender,

    domains,
    subscribers,

    reqLDRates,
    integrators,
    integratorCompanies,
    companyUser,
    tcOrders,
    tcRequests,
    linksList,

    flagCompliance,
    tcIndexes,

    cargoTagsCategories,

    issues,
    issue,
});



// WEBPACK FOOTER //
// ./app/reducers/index.js